import React, { useState, useEffect, useCallback } from "react";
import URLManager from "../funcionalidadeNavbar/URLManager";
import { Button, Modal, Box, Paper, Snackbar } from "@mui/material";
import PermissionGate from "./PermissionGate";
import CadastrarUsuarioTabela from "./CadastrarUsuarioTabela";
import CadastrarUsuarioFormulario from "./CadastrarUruarioFormulario";


const CadastrarUsuario = () => {
    const _url = URLManager.getBaseURL()
    const usario = {
        id: 0,
        name: '',
        email: '',
        password: '',
        phone: '',
        status: '',
        idEmpresa: '',
        perfilId: ''
    }


    const [popperMessage, setPopperMessage] = useState('');
    const [objUsuario, setObjUsuario] = useState(usario);
    const [usuarios, setUsuarios] = useState([]);
    const [perfis, setPerfis] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [btnUsuario, setBtnUsuario] = useState(true);

    // Adicione este estado para controle do Snackbar
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    // Função para mostrar o popper com uma mensagem e fechar após 3 segundos
    const mostrarMensagem = (mensagem) => {
        setPopperMessage(mensagem);
        setSnackbarOpen(true);
        setTimeout(() => setSnackbarOpen(false), 3000);
    };

    const handleCloseModal = () => {
        limparUsuario();
        setOpenModal(false);
    }

    const handleOpenModal = () => {
        setObjUsuario(usario);
        setOpenModal(true);
    }

    const handleChange = (e) => {
        setObjUsuario({ ...objUsuario, [e.target.name]: e.target.value });
    };

    // Limpar Materia Prima
    const limparUsuario = () => {
        setObjUsuario(usario);
        setBtnUsuario(true);

    };

    const digitar = (e) => {
        setObjUsuario({ ...objUsuario, [e.target.name]: e.target.value });
    };

    const cadastrarUsuarios = () => {

        const cadastrarComEmpresa = {
            ...objUsuario,
            idEmpresa: objUsuario.idEmpresa,
        }
        fetch(`${_url}/user/${objUsuario.idEmpresa}`, {
            method: 'POST',
            body: JSON.stringify(cadastrarComEmpresa),
            headers: {
                'Content-Type': 'application/json',
                Accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
            },
        })
            .then((retorno) => retorno.json())
            .then((retorno_convertido) => {
                if (retorno_convertido.mensagem) {
                    mostrarMensagem(retorno_convertido.mensagem);
                } else {
                    setUsuarios([...usuarios, retorno_convertido]);
                    mostrarMensagem('Usuario cadastrado com sucesso!')
                    limparUsuario();
                    carregarUsuarios();
                    handleCloseModal();
                }
            })
    }

    

    const carregarUsuarios = useCallback(() => {
        fetch(`${_url}/user/listar`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
            },
        })
            .then((res) => res.json())
            .then((dados) => setUsuarios(dados))
            .catch((erro) => console.error("Erro ao carregar usuários:", erro));
    }, [_url]);

    const carregarEmpresas = useCallback(() => {
        fetch(`${_url}/empresa/listar`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
            },
        })
            .then((retorno) => retorno.json())
            .then((dados) => setEmpresas(dados))
            .catch((error) => console.error('Erro ao carregar Empresa:', error));
    }, [_url]); 


    const carregarPerfis = useCallback(() => {
        fetch(`${_url}/perfil/listar`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
            },
        })
            .then((retorno) => retorno.json())
            .then((dados) => setPerfis(dados))
            .catch((error) => console.error('Erro ao carregar perfil:', error));
    }, [_url]);

    useEffect(() => {
        console.log("Dados dos usuários:", usuarios);
        console.log("Dados dos perfis:", perfis);
        console.log("Dados completos dos usuários:", JSON.stringify(usuarios, null, 2));
    }, [usuarios, perfis]);


    // Selecionar MateriaPrima
    const editar = (id) => {
        const usuarioSelecionado = usuarios.find(user => user.id === id);

        if (!usuarioSelecionado) {
            mostrarMensagem("Usuário não encontrado");
            return;
        }

        setObjUsuario({
            ...usuarioSelecionado,
            idEmpresa: usuarioSelecionado.idEmpresa?.id || usuarioSelecionado.idEmpresa,
            perfilId: usuarioSelecionado.perfilId?.id || usuarioSelecionado.perfilId
        });
        setBtnUsuario(false); // Isso já está correto
        setOpenModal(true);
    };


    const remover = () => {
        fetch(`${_url}/user/remover/${objUsuario.id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Accept: "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
          },
        })
          .then((retorno) => retorno.json())
          .then((retorno_convertido) => {
            mostrarMensagem(retorno_convertido.mensagem || "Usuario removido");
            carregarUsuarios();
            limparUsuario();
            handleCloseModal();
    
          });
      };


    // Alterar MateriaPrima
  const alterarUsuario = () => {
    console.log('Dados a serem enviados:', objUsuario);
    fetch(`${_url}/user/alterar/${objUsuario.id}`, {
      method: 'PUT',
      body: JSON.stringify({
        id: objUsuario.id,
        name: objUsuario.name,
        email: objUsuario.email,
        password: objUsuario.password,
        phone: objUsuario.phone,
        status: objUsuario.status,
        idEmpresa: objUsuario.idEmpresa,
        perfilId: objUsuario.perfilId
      }),
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.mensagem) {
          alert(data.mensagem);
        } else {
          const updatedUsuario = usuarios.map(usario =>
            usario.id === objUsuario.id ? { ...usario, ...objUsuario } : usario
          );
          setUsuarios(updatedUsuario);
          mostrarMensagem('Usuario alterada com sucesso!');
          carregarUsuarios();
          limparUsuario();
          handleCloseModal();
        }
      })
      .catch(error => {
        console.error('Erro ao alterar usuario:', error);
        mostrarMensagem('Erro ao alterar usuario');
      });
  };

    useEffect(() => {
        carregarUsuarios();
        carregarPerfis();
        carregarEmpresas();
    },[carregarEmpresas,carregarPerfis,carregarUsuarios]);




    return (
        <PermissionGate permissions={["cadastrarUsuarios"]}>
        <div>
                <div className="button-cadastrarMateria"> {/* Utilizando o estilo de botao de do css de materia prima*/ }
                    <Button variant="contained" color="primary" onClick={handleOpenModal}>
                        Cadastrar Usuário
                    </Button>
                </div>
            

            {/* Modal de Cadastro */}
            <Modal open={openModal} onClose={handleCloseModal}>
                <Box
                    sx={{
                        position: "absolute",
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50% )',
                        width: 450,
                        maxHeight: '85vh',
                        overflowY: 'auto',
                        p: 3,
                    }}
                >
                    <Paper style={{
                        padding: '15px',
                        color: '#333',
                        textAlign: 'center',
                        fontSize: '16px',
                        borderRadius: '20px',
                        background: 'rgba(255, 255, 255, 0.98)',
                        backdropFilter: 'blur(20px)',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div className="modal-title">
                            {btnUsuario ? 'Cadastrar Usuário' : 'Editar Usuário'}
                        </div>

                        <CadastrarUsuarioFormulario
                            eventoTeclado={digitar}
                            botao={btnUsuario}
                            cadastrarUsuario={cadastrarUsuarios}
                            alterarUsuario={alterarUsuario}
                            obj={objUsuario}
                            empresas={empresas}
                            perfis={perfis}
                            carregarEmpresas={carregarEmpresas}
                            carregarPerfis={carregarPerfis}
                            remover={remover}
                            handleChange={handleChange}
                        />
                        
                        <div className="modal-buttons">
                            <button onClick={handleCloseModal} className='modal-button modal-button-close'>
                                Fechar
                            </button>
                        </div>
                    </Paper>
                </Box>
            </Modal>

            <CadastrarUsuarioTabela
                vetor={usuarios}
                editar={editar}
                perfis={perfis}
            />

            {/* Snackbar de Mensagem */}
            <Snackbar
                open={snackbarOpen}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                message={popperMessage}
            />
                </div>
                </PermissionGate>
    );
};


export default CadastrarUsuario;
